// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__mt9ym","rootSmall":"AddTileButton_rootSmall__2UAum"};